import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import {Route, RouterModule} from '@angular/router';
import { MainFormComponent } from './main-form/main-form.component';
import { LoginComponent } from './login/login.component';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { SrPendientesComponent } from './sr-pendientes/sr-pendientes.component';
import { SrFormComponent } from './components/sr-form/sr-form.component';
import { EtFormComponent } from './components/et-form/et-form.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpRequestInterceptor } from './HttpRequestInterceptor';
import {PdfMakeWrapper} from 'pdfmake-wrapper';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { ConsultaClienteComponent } from './components/consulta-cliente/consulta-cliente.component';
import { EtEnvioFormComponent } from './components/et-envio-form/et-envio-form.component';
import { VehiculoFormComponent } from './components/vehiculo-form/vehiculo-form.component';
import { VehiculosComponent } from './components/vehiculos/vehiculos.component';
import { PersonalComponent } from './components/personal/personal.component';
import { UsuarioFormComponent } from './components/usuario-form/usuario-form.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeES from '@angular/common/locales/es';
import { RechazoComponent } from './components/rechazo/rechazo.component';
import { ConformadoComponent } from './components/conformado/conformado.component';
import { SrHistoricoComponent } from './components/sr-historico/sr-historico.component';
import {DatePipe} from '@angular/common';
import  {MatNativeDateModule} from '@angular/material/core';
import  {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LogonComponent } from './components/logon/logon.component';
import { ActivarComponent } from './components/activar/activar.component';
import { RutaFormComponent } from './components/ruta-form/ruta-form.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { DireccionFormComponent } from './components/direccion-form/direccion-form.component';
import { ClientePedidosComponent } from './components/cliente-pedidos/cliente-pedidos.component';
registerLocaleData(localeFr,localeES);
// var pdfFronts=require('pdfmake/build/vfs_fonts.js');
   PdfMakeWrapper.setFonts(pdfFonts);

const routes: Route[]= [
  // {path: '', component: LoginComponent},
  // {path: 'home', component: HomeComponent},
  // {path: 'main', component: MainFormComponent},
  // {path: 'login', component: LoginComponent},
  // {path: 'sr', component: SrPendientesComponent}
]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainFormComponent,
    LoginComponent,
    SrPendientesComponent,
    SrFormComponent,
    EtFormComponent,
    ConsultaClienteComponent,
    EtEnvioFormComponent,
    VehiculoFormComponent,
    VehiculosComponent,
    PersonalComponent,
    UsuarioFormComponent,
    RechazoComponent,
    ConformadoComponent,
    SrHistoricoComponent,
    LogonComponent,
    ActivarComponent,
    RutaFormComponent,
    PerfilComponent,
    DireccionFormComponent,
    ClientePedidosComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,MatInputModule
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR'},DatePipe,{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
